import axios from 'axios'

export const DEFAULT_SPINE_CONFIG_KEY = 'shunyi_home'

export const DEFAULT_SPINE_ICON = `<svg width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M20 4L4 14L20 24L36 14L20 4Z" fill="#5CB8E6" opacity="0.85"/>
  <path d="M4 18L20 28L36 18" stroke="#5CB8E6" stroke-width="3" stroke-linecap="round"/>
  <path d="M4 26L20 36L36 26" stroke="#5CB8E6" stroke-width="3" stroke-linecap="round"/>
</svg>`

export function normalizeSpineConfig (config) {
  const normalized = Object.assign({
    hospital: {},
    courseSort: '29G',
    sciencePopularizationList: []
  }, config || {})

  normalized.hospital = Object.assign({
    id: 'shunyi001',
    name: '健康顺德脊柱侧弯康复中心',
    mainImg: 'https://cdn.keihong.tech/img/202412091556356.png',
    bannerList: [],
    doctors: []
  }, normalized.hospital || {})

  normalized.hospital.bannerList = (normalized.hospital.bannerList || []).map(item => Object.assign({
    title: '',
    img: '',
    articleId: '',
    category: '',
    categoryId: null
  }, item))

  normalized.hospital.doctors = normalized.hospital.doctors || []

  normalized.sciencePopularizationList = (normalized.sciencePopularizationList || []).map(item => Object.assign({
    label: '',
    gradient: '#FFFFFF',
    icon: DEFAULT_SPINE_ICON,
    category: '',
    articleId: '',
    categoryId: null
  }, item))

  return normalized
}

export default {
  async load (configKey = DEFAULT_SPINE_CONFIG_KEY) {
    const { data: resp } = await axios.get('/spine/config/load', { params: { configKey } })
    if (resp && resp.code === 200 && resp.data && resp.data.configJson) {
      return normalizeSpineConfig(JSON.parse(resp.data.configJson))
    }
    throw new Error((resp && resp.message) || '加载脊柱侧弯配置失败')
  }
}
